import {
  Box,
  Button,
  Grid,
  CircularProgress,
  MenuItem,
  Typography,
  IconButton,
  Select,
} from "@mui/material";
import { CenteredBox } from "../../../components/layouts/common/boxes";
import { useDispatch, useSelector } from "react-redux";
import {
  DEVICES,
  FITTING_BUTTON,
  LISTENING_SIDE,
  MODES,
  RIC_8_MODES,
} from "../../../utils/patient.constants";
import NoDataComponent from "../../../components/layouts/NoDataComponent";
import { Error, VolumeOff, VolumeUp } from "@mui/icons-material";
import {
  applyForRemoteFitting,
  changeFittingData,
  changeProfileId,
  resetReducer,
} from "../../../store/actions/fittingAction";
import { useEffect, useState } from "react";
import PropTypes from "prop-types";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import { useNavigate, useParams } from "react-router-dom";
import {
  addPatientProfileApi,
  getPatientProfileByIdApi,
  updatePatientProfileField,
} from "../../../apis/patientprofile.api";
import { callApiAction } from "../../../store/actions/commonAction";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { callSnackBar } from "../../../store/actions/snackbarAction";
import { SNACK_BAR_VARIETNS } from "../../../utils/constants";
import ConfigAssistantController from ".././ConfigAssistantController";
import { closeModal, openModal } from "../../../store/actions/modalAction";
import RicBasicFittingAreaController from "./RicBasicFittingAreaController";
import {
  changeRicMode,
  disconnectRicDevice,
  readBatteryLevel,
  setRicFittingData,
  toggleMute,
} from "../../../store/actions/ricFittingActions";
import RicFineTunningController from "./RicFineTunningController";
import RicManageProgramController from "./RicManageProgramController";
import RicCompleteSessionController from "./RicCompleteSessionController";
import WriteRicDataToDevice from "./WriteRicDataToDevice";

function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box>{children}</Box>}
    </div>
  );
}

CustomTabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const RicFittingMainController = () => {
  const dispatch = useDispatch();
  const { fitting } = useSelector((state) => state);
  const { fittingLeft } = useSelector((state) => state);
  const { ricLeftFitting } = useSelector((state) => state);
  const { ricRightFitting } = useSelector((state) => state);

  const [loading, setLoading] = useState(false);
  const params = useParams();
  const [value, setValue] = useState(1);
  const [shouldUpdate, setShouldUpdate] = useState(false);

  const [isRest, setIsReset] = useState(false);

  const [showBackDialog, setShowBackDialog] = useState(false);

  const handleBackClick = () => {
    if (ricLeftFitting.read_only || ricRightFitting.read_only) {
      navigate(`/patient-details/${params.id}`);
      return;
    }

    setselectButton(FITTING_BUTTON.COMPLETE_SESSION);
    dispatch(
      openModal(
        <RicCompleteSessionController
          onCompleteSession={onCompleteSession}
          id="complete"
          isBackButton={true}
          onCancel={() => {
            setselectButton(FITTING_BUTTON.BASIC_FITTING);
            setValue(1);
          }}
        />,
        "sm",
        false,
        "complete"
      )
    );
  };

  const handleCloseBackDialog = () => {
    dispatch(closeModal("back-confirmation"));
  };

  const handleConfirmBack = () => {
    setShowBackDialog(false);
    if (ricRightFitting.connected && !ricRightFitting.remote) {
      dispatch(disconnectRicDevice(ricRightFitting.device_side));
    }
    if (ricLeftFitting.connected && !ricLeftFitting.remote) {
      dispatch(disconnectRicDevice(ricLeftFitting.device_side));
    }
    navigate(`/patient-details/${params.id}`);
  };

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  const navigate = useNavigate();

  useEffect(() => {
    return () => {
      dispatch(resetReducer());
    };
  }, []);

  const onFineTunning = () => {
    setselectButton(FITTING_BUTTON.FINE_TUNNING);
  };

  const [completeLoading, setCompleteLoading] = useState(false);
  const [saveLoadin, setSaveLoading] = useState(false);
  const [isLeftMuted, setIsLeftMuted] = useState(false);
  const [isRightMuted, setIsRightMuted] = useState(false);
  const handleLeftToggleMute = () => {
    dispatch(
      toggleMute(!isLeftMuted, LISTENING_SIDE.LEFT, ricLeftFitting.deviceObj)
    );
    setIsLeftMuted(!isLeftMuted);
  };
  const handleRightToggleMute = () => {
    dispatch(
      toggleMute(!isRightMuted, LISTENING_SIDE.RIGHT, ricRightFitting.deviceObj)
    );
    setIsRightMuted(!isRightMuted);
  };

  const [complete, setComplete] = useState(false);

  useEffect(() => {
    if (complete) {
      navigate(`/patient-details/${params.id}`);
      if (
        (ricRightFitting.connected &&
          !ricRightFitting.read_only &&
          !ricRightFitting.remote) ||
        (ricLeftFitting.connected &&
          !ricLeftFitting.read_only &&
          !ricLeftFitting.remote)
      ) {
        dispatch(disconnectRicDevice(LISTENING_SIDE.LEFT));
        dispatch(disconnectRicDevice(LISTENING_SIDE.RIGHT));
      }
      setComplete(false);
    }
  }, [complete]);

  const fetchById = (id) => {
    setLoading(true);
    dispatch(
      callApiAction(
        async () => await getPatientProfileByIdApi({ id }),
        async (response) => {
          if (response && response._id) {
            console.log("this is response", response);
            dispatch(
              changeFittingData(response, params.readonly, response.device_side)
            );
            setShouldUpdate(true);

            if (
              response.device_type === DEVICES.RIC_OPTIMA ||
              response.device_type === DEVICES.RIC_OPTIMA_8
            ) {
              dispatch(
                setRicFittingData(
                  response,
                  params.readonly,
                  response.device_side
                )
              );
            }
          } else {
          }
          if (response.device_side === LISTENING_SIDE.LEFT) {
            if (!fittingLeft.connected && !params.readonly) {
              dispatch(applyForRemoteFitting(LISTENING_SIDE.LEFT));
            }
          } else {
            if (!fitting.connected && !params.readonly) {
              dispatch(applyForRemoteFitting(LISTENING_SIDE.RIGHT));
            }
          }
          setLoading(false);
        },
        (err) => {
          setLoading(false);
        }
      )
    );
  };

  useEffect(() => {
    if (
      (ricRightFitting.device_type === DEVICES.RIC_OPTIMA_8 &&
        ricRightFitting.ric_mode != 0) ||
      (ricLeftFitting.device_type === DEVICES.RIC_OPTIMA_8 &&
        ricLeftFitting.ric_mode != 0)
    ) {
      setselectButton(FITTING_BUTTON.MANAGE_PROGRAM);
    }
  }, [ricLeftFitting.ric_mode, ricRightFitting.ric_mode]);

  useEffect(() => {
    if (params.fitid) {
      fetchById(params.fitid);
    }

    if (params.fitid1) {
      fetchById(params.fitid1);
    }
  }, [params.fitid, params.fitid1]);

  const [selectButton, setselectButton] = useState(
    FITTING_BUTTON.BASIC_FITTING
  );

  const gatherFittingData = (fitting) => {
    return {
      patient_id: params.id,
      device_id: fitting.deviceInfo?.id,
      device_name: fitting.deviceInfo?.name,
      device_side: fitting.device_side,
      device_type: fitting.device_type,
      eq_values: fitting.eqValues,
      mode_type: fitting.ric_mode,
      mpo_value: fitting.mpoValue,

      mode_data: Object.values(fitting.tempModes).map((mode) => ({
        eq_values: mode.eqValues,
        sharpness: mode.ric_sharpness_reduction,
        feedback_cancellation: mode.feedbackCancellation,
        self_speech_reduction: mode.selfSpeechReduction,
        master_gain: mode.ricMasterGain,
        noise_reduction: mode.noiseReduction,
        mpo_value: mode.mpoValue,
      })),
      noise_reduction: fitting.ric_noise_reduction,

      self_speech_reduction: fitting.self_speech_reduction,
      sharpness: fitting.ric_sharpness_reduction,
      feedback_cancellation: fitting.feedback_cancellation,
      master_gain: fitting.ric_master_gain,
      remarks: fitting.remarks,
    };
  };

  const onSaveFittingHelper = async (
    complete,
    callBack = () => {},
    callBack1 = () => {},
    nextStep,
    fittingData
  ) => {
    try {
      const passData = {
        patient_id: params.id,
        device_id: fittingData.device_id,
        device_name: fittingData.device_name,
        device_side: fittingData.device_side,
        device_type: fittingData.device_type,
        eq_values: fittingData.eq_values,
        mode_data: fittingData.mode_data,
        noise_reduction: fittingData.noise_reduction,
        remarks: fittingData.remarks,
        mpo_value: fittingData.mpo_value,
        self_speech_reduction: fittingData.self_speech_reduction,
        sharpness: fittingData.sharpness,
        mode_type: fittingData.mode_type,
        feedback_cancellation: fittingData.feedback_cancellation,
        master_gain: fittingData.master_gain,
      };

      if (fittingData.profile_id) {
        dispatch(
          callApiAction(
            async () =>
              await updatePatientProfileField({
                id: fittingData.profile_id,
                ...passData,
              }),
            async (response) => {
              if (nextStep) {
                callBack();
                callBack1();
                dispatch(
                  callSnackBar(
                    " Fitting Saved Successfully",
                    SNACK_BAR_VARIETNS.suceess
                  )
                );
              }
              if (complete === true) setCompleteLoading(false);
              else {
                setSaveLoading(false);
              }
            },
            (err) => {
              if (complete === true) setCompleteLoading(false);
              else {
                setSaveLoading(false);
              }
              dispatch(callSnackBar(err, SNACK_BAR_VARIETNS.error));
            }
          )
        );
      } else {
        console.log("2");
        dispatch(
          callApiAction(
            async () => await addPatientProfileApi(passData),
            async (response) => {
              dispatch(changeProfileId(response._id, fittingData.device_side));

              if (nextStep) {
                callBack();
                callBack1();
                dispatch(
                  callSnackBar(
                    " Fitting Saved Successfully",
                    SNACK_BAR_VARIETNS.suceess
                  )
                );
              }
              if (complete === true) setCompleteLoading(false);
              else {
                setSaveLoading(false);
              }
            },
            (err) => {
              if (complete === true) setCompleteLoading(false);
              else {
                setSaveLoading(false);
              }
              dispatch(callSnackBar(err, SNACK_BAR_VARIETNS.error));
            }
          )
        );
      }
    } catch (error) {
      console.error("API Error:", error);
      dispatch(callSnackBar("Error saving data", SNACK_BAR_VARIETNS.error));
      callBack1();
    }
  };

  const onOneSaveFitting = async (e, Fitting, ricFitting) => {
    e.preventDefault();
    // setCompleteLoading(true);
    console.log("this is Fitting inside the onOneSaveFitting", Fitting);

    const fittingData = gatherFittingData(Fitting, Fitting.remarks);

    // let success = true;

    await onSaveFittingHelper(
      !ricFitting?.connected,
      () => {},
      () => {},
      true,
      fittingData
    ).catch(() => {
      // success = false;
    });
    // setCompleteLoading(false);
    dispatch(closeModal("complete"));

    if (!ricFitting?.connected) {
      setComplete(true);
    }
  };

  const onCompleteSession = async (e, rightFitting, leftFitting) => {
    e.preventDefault();
    setCompleteLoading(true);

    const fittingDataRight = gatherFittingData(
      rightFitting,
      rightFitting.remarks
    );
    const fittingDataLeft = gatherFittingData(leftFitting, leftFitting.remarks);

    let success = true;

    if (rightFitting.connected) {
      await onSaveFittingHelper(
        true,
        () => {
          dispatch(disconnectRicDevice(rightFitting.device_side));
        },
        () => {},
        true,
        fittingDataRight
      ).catch(() => {
        success = false;
      });
    }

    if (leftFitting.connected) {
      await onSaveFittingHelper(
        true,
        () => {
          dispatch(disconnectRicDevice(leftFitting.device_side));
        },
        () => {},
        true,
        fittingDataLeft
      ).catch(() => {
        success = false;
      });
    }

    setCompleteLoading(false);
    dispatch(closeModal("complete"));

    if (success) {
      setComplete(true);
    }
  };

  useEffect(() => {
    if (shouldUpdate) {
      setShouldUpdate(false);
    }
  }, [shouldUpdate]);

  useEffect(() => {
    console.log("this is jay", ricRightFitting);
    if (
      !ricRightFitting.connected &&
      !ricRightFitting.read_only &&
      !ricRightFitting.remote &&
      (params.fitid == null || params.fitid1 == null) &&
      ricRightFitting?.prevData?.connected
    ) {
      dispatch(
        openModal(
          <RicCompleteSessionController
            onCompleteSession={(e) => {
              onOneSaveFitting(e, ricRightFitting?.prevData, ricLeftFitting);
            }}
            id="complete"
            singleSide={ricRightFitting?.prevData}
            disableDirectClose={true}
            onCancel={() => {
              if (ricLeftFitting.connected) {
                dispatch(closeModal("complete"));
              } else {
                dispatch(closeModal("complete"));
                setComplete(true);
              }
            }}
          />,
          "sm",
          false,
          "complete"
        )
      );
    }
    //  else {
    //   navigate(`/patient-details/${params.id}`);
    // }
  }, [ricRightFitting.connected]);

  useEffect(() => {
    console.log("this is PrevData....", ricLeftFitting?.prevData);
    if (
      !ricLeftFitting.connected &&
      !ricLeftFitting.read_only &&
      !ricLeftFitting.remote &&
      (params.fitid == null || params.fitid1 == null) &&
      ricLeftFitting?.prevData?.connected
    ) {
      dispatch(
        openModal(
          <RicCompleteSessionController
            onCompleteSession={(e) => {
              onOneSaveFitting(e, ricLeftFitting?.prevData, ricRightFitting);
            }}
            id="complete"
            disableDirectClose={true}
            singleSide={ricLeftFitting?.prevData}
            onCancel={() => {
              if (ricLeftFitting.connected) {
                dispatch(closeModal("complete"));
              } else {
                dispatch(closeModal("complete"));
                setComplete(true);
              }
            }}
          />,
          "sm",
          false,
          "complete"
        )
      );
    }
    //  else {
    //   navigate(`/patient-details/${params.id}`);
    // }
  }, [ricLeftFitting.connected]);

  // useEffect(() => {
  //   if (complete) {
  //     navigate(`/patient-details/${params.id}`);
  //     if (
  //       (ricRightFitting.connected &&
  //         !ricRightFitting.read_only &&
  //         !ricRightFitting.remote) ||
  //       (ricLeftFitting.connected &&
  //         !ricLeftFitting.read_only &&
  //         !ricLeftFitting.remote)
  //     ) {
  //       dispatch(disconnectRicDevice(LISTENING_SIDE.LEFT));
  //       dispatch(disconnectRicDevice(LISTENING_SIDE.RIGHT));
  //     }
  //     setComplete(false);
  //   }
  // }, [complete]);

  return (
    <>
      {loading || completeLoading ? (
        <Box sx={{ paddingTop: "50vh" }}>
          <CenteredBox>
            <CircularProgress />
          </CenteredBox>
        </Box>
      ) : (
        <>
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              borderBottom: 1,
              borderColor: "divider",
            }}
          >
            <Box sx={{ display: "flex", flexDirection: "row", width: "42%" }}>
              <IconButton sx={{ marginRight: "5px" }} onClick={handleBackClick}>
                <ArrowBackIcon sx={{ color: "#2D3B67" }} fontSize="medium" />
              </IconButton>
              <Tabs
                value={value}
                aria-label="basic tabs example"
                sx={{ height: "0px" }}
              >
                <Tab label="Fitting" {...a11yProps(1)} />
              </Tabs>
            </Box>
            <Box
              width={{ xs: "90%", sm: "50%", md: "28%" }}
              display="flex"
              justifyContent="center"
              alignItems="center"
            >
              <Select
                sx={{
                  height: "7.6vh",
                  fontSize: "16px",
                  fontFamily: "League Spartan",
                  color: "#4D4D4D",
                  width: { xs: "80vw", sm: "50vw", md: "13vw" },
                  minWidth: "150px",
                  maxWidth: "100%",
                  backgroundColor: "#EDF0F7",
                  borderRadius: "0px",
                  textAlign: "center",
                }}
                value={ricRightFitting.ric_mode}
                onChange={(event) => {
                  const selectedMode = event.target.value;

                  dispatch(
                    changeRicMode(
                      selectedMode,
                      LISTENING_SIDE.RIGHT,
                      ricRightFitting.deviceObj
                    )
                  );
                  dispatch(
                    changeRicMode(
                      selectedMode,
                      LISTENING_SIDE.LEFT,
                      ricLeftFitting.deviceObj
                    )
                  );
                }}
              >
                {ricRightFitting.device_type == DEVICES.RIC_OPTIMA ||
                ricLeftFitting.device_type == DEVICES.RIC_OPTIMA
                  ? MODES.map((item) => (
                      <MenuItem key={item.value} value={item.value}>
                        <Typography
                          sx={{
                            color: "#2D3B67",
                            fontWeight: "500",
                            fontFamily: "League Spartan",
                            fontSize: "14px",
                            whiteSpace: "nowrap",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                          }}
                        >
                          {item.label}
                        </Typography>
                      </MenuItem>
                    ))
                  : RIC_8_MODES.map((item) => (
                      <MenuItem key={item.value} value={item.value}>
                        <Typography
                          sx={{
                            color: "#2D3B67",
                            fontWeight: "500",
                            fontFamily: "League Spartan",
                            fontSize: "14px",
                            whiteSpace: "nowrap",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                          }}
                        >
                          {item.label}
                        </Typography>
                      </MenuItem>
                    ))}
              </Select>
            </Box>

            <Box width="30%" display={"flex"} justifyContent="flex-end">
              {!(
                ricRightFitting.read_only ||
                ricLeftFitting.remote ||
                ricLeftFitting.read_only ||
                ricLeftFitting.remote
              ) &&
                (ricLeftFitting.device_type == DEVICES.RIC_OPTIMA ||
                  ricRightFitting.device_type == DEVICES.RIC_OPTIMA) && (
                  <Box mt={2}>
                    <Button
                      onClick={handleRightToggleMute}
                      disabled={!ricRightFitting.connected}
                      sx={{
                        textDecoration: "underline",
                        fontFamily: "League spartan",
                        fontSize: "20px",
                        fontWeight: "bold",
                        color: "#C24747",
                      }}
                    >
                      {isRightMuted ? (
                        <VolumeOff sx={{ transform: "scaleX(-1)" }} />
                      ) : (
                        <VolumeUp sx={{ transform: "scaleX(-1)" }} />
                      )}
                    </Button>
                    <Button
                      onClick={handleLeftToggleMute}
                      disabled={!ricLeftFitting.connected}
                      sx={{
                        textDecoration: "underline",
                        fontFamily: "League spartan",
                        fontSize: "20px",
                        fontWeight: "bold",
                        color: "#1265A1",
                      }}
                    >
                      {isLeftMuted ? <VolumeOff /> : <VolumeUp />}
                    </Button>
                  </Box>
                )}
            </Box>
          </Box>

          {!loading && ricRightFitting.enabled === false && (
            <NoDataComponent
              message={"Your browser does'nt support this software."}
              Icon={Error}
            />
          )}
          <CustomTabPanel value={value} index={1} sx={{ height: "0px" }}>
            <Grid container>
              <Grid md={1.7} xs={1.7}>
                <Box
                  p={2}
                  height={"100vh"}
                  sx={{ borderRight: "1px solid #DDDDDD" }}
                >
                  <Box>
                    <Button
                      disabled={
                        (ricRightFitting.device_type === DEVICES.RIC_OPTIMA_8 &&
                          ricRightFitting.ric_mode != 0) ||
                        (ricLeftFitting.device_type === DEVICES.RIC_OPTIMA_8 &&
                          ricRightFitting.ric_mode != 0)
                      }
                      sx={{
                        fontFamily: "League spartan",
                        width: "13vw",
                        height: "6vh",
                        display: "flex",
                        justifyContent: "flex-start",
                        backgroundColor:
                          selectButton === FITTING_BUTTON.BASIC_FITTING
                            ? "#EDF0F7"
                            : "white",
                        border:
                          selectButton === FITTING_BUTTON.BASIC_FITTING
                            ? "1px solid #2D3B67"
                            : "1px solid #F2F2F2",
                      }}
                      onClick={() => {
                        setselectButton(FITTING_BUTTON.BASIC_FITTING);
                      }}
                    >
                      <Typography variant="h6">Basic Fitting</Typography>
                    </Button>
                  </Box>
                  <Box mt={2}>
                    <Button
                      disabled={
                        (ricRightFitting.device_type === DEVICES.RIC_OPTIMA_8 &&
                          ricRightFitting.ric_mode != 0) ||
                        (ricLeftFitting.device_type === DEVICES.RIC_OPTIMA_8 &&
                          ricRightFitting.ric_mode != 0)
                      }
                      sx={{
                        fontFamily: "League spartan",
                        fontSize: "16px",
                        width: "13vw",
                        fontWeight: "large",
                        height: "6vh",
                        display: "flex",
                        justifyContent: "flex-start",
                        backgroundColor:
                          selectButton === FITTING_BUTTON.FINE_TUNNING
                            ? "#EDF0F7"
                            : "white",
                        border:
                          selectButton === FITTING_BUTTON.FINE_TUNNING
                            ? "1px solid #2D3B67"
                            : "1px solid #F2F2F2",
                      }}
                      onClick={onFineTunning}
                    >
                      <Typography variant="h6">Fine Tunning</Typography>
                    </Button>
                  </Box>

                  <Box mt={2}>
                    <Button
                      sx={{
                        fontFamily: "League spartan",
                        fontSize: "16px",
                        width: "13vw",
                        fontWeight: "large",
                        height: "6vh",
                        display: "flex",
                        justifyContent: "flex-start",
                        backgroundColor:
                          selectButton === FITTING_BUTTON.MANAGE_PROGRAM
                            ? "#EDF0F7"
                            : "white",
                        border:
                          selectButton === FITTING_BUTTON.MANAGE_PROGRAM
                            ? "1px solid #2D3B67"
                            : "1px solid #F2F2F2",
                      }}
                      onClick={() => {
                        setselectButton(FITTING_BUTTON.MANAGE_PROGRAM);
                      }}
                    >
                      <Typography variant="h6"> Manage Program</Typography>
                    </Button>
                  </Box>

                  {!(ricRightFitting.read_only || ricLeftFitting.read_only) && (
                    <Box mt={2}>
                      <Button
                        sx={{
                          fontFamily: "League spartan",
                          fontSize: "16px",
                          width: "13vw",
                          fontWeight: "large",
                          height: "6vh",
                          display: "flex",
                          justifyContent: "flex-start",
                          backgroundColor:
                            selectButton === FITTING_BUTTON.COMPLETE_SESSION
                              ? "#EDF0F7"
                              : "white",
                          border:
                            selectButton === FITTING_BUTTON.COMPLETE_SESSION
                              ? "1px solid #2D3B67"
                              : "1px solid #F2F2F2",
                        }}
                        onClick={() => {
                          setselectButton(FITTING_BUTTON.COMPLETE_SESSION);
                          dispatch(
                            openModal(
                              <RicCompleteSessionController
                                onCompleteSession={onCompleteSession}
                                onCancel={() => {
                                  if (
                                    (ricLeftFitting.ric_mode != 0 &&
                                      ricLeftFitting.device_type ===
                                        DEVICES.RIC_OPTIMA_8) ||
                                    (ricRightFitting.ric_mode != 0 &&
                                      ricRightFitting.device_type ===
                                        DEVICES.RIC_OPTIMA_8)
                                  ) {
                                    setselectButton(
                                      FITTING_BUTTON.MANAGE_PROGRAM
                                    );
                                  } else {
                                    setselectButton(
                                      FITTING_BUTTON.BASIC_FITTING
                                    );
                                  }
                                  setValue(1);
                                }}
                                id="complete"
                              />,
                              "sm",
                              false,
                              "complete"
                            )
                          );
                        }}
                      >
                        <Typography variant="h6">Complete Session</Typography>
                      </Button>
                    </Box>
                  )}
                </Box>
              </Grid>
              {value == 1 && selectButton === FITTING_BUTTON.BASIC_FITTING && (
                <Grid item xs={10}>
                  <RicBasicFittingAreaController />
                </Grid>
              )}
              {value == 1 && selectButton === FITTING_BUTTON.FINE_TUNNING && (
                <Grid item xs={10}>
                  <RicFineTunningController setShouldUpdate={setShouldUpdate} />
                </Grid>
              )}
              {value == 1 && selectButton === FITTING_BUTTON.MANAGE_PROGRAM && (
                <Grid item xs={10}>
                  <RicManageProgramController />
                </Grid>
              )}

              {value == 1 &&
                selectButton === FITTING_BUTTON.CONFIG_ASSISTANT && (
                  <Grid item xs={10}>
                    <ConfigAssistantController
                      isRest={isRest}
                      setIsReset={setIsReset}
                    />
                  </Grid>
                )}
            </Grid>
          </CustomTabPanel>
        </>
      )}
    </>
  );
};

export default RicFittingMainController;
